<template>
  <div>
    <newAppNav :isDesktop="isDesktop"/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import newAppNav from './newAppNav.vue'
export default {
  data () {
    return {
      currentMenu: '',
      isDesktop: this.$parent.isDesktop
    }
  },
  components: {
    newAppNav
  },
  computed: {
    ...mapGetters({
      supimaLandingData: 'supimaLandingData',
      isLandingPageSubMenu: 'isLandingPageSubMenu',
      activeWearLandingData: 'activeWearLandingData',
      globalBannerPlaceholder: 'globalBannerPlaceholder'
    }),
    supimaMenuData () {
      const navbarWidget = this.supimaLandingData && Object.values(this.supimaLandingData).find(item => item && item[item.length - 1] && item[item.length - 1][1] === 'name banner')
      return (navbarWidget && navbarWidget.slice(0, -1)) || []
    },
    isSupimaMenu () {
      return this.$route.path && this.$route.path.includes('supima-landing')
    },
    activeWearMenuData () {
      const navbarWidget = this.activeWearLandingData && Object.values(this.activeWearLandingData).find(item => item && item[item.length - 1] && item[item.length - 1][1] === 'name banner')
      return (navbarWidget && navbarWidget.slice(0, -1)) || []
    },
    isActiveWearMenu () {
      return this.$route.path && this.$route.path.includes('active-wear-landing')
    },
    isWinterWearMenu () {
      return this.$route.path && this.$route.path.includes('winter-wear-landing')
    },
    landingPageGender () {
      return this.$route && this.$route.params && this.$route.params.gender === 'women' ? 2 : 1
    },
    showNewSideNavMenu: function () {
      return this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_NEW_SIDE_NAV_WEB')
    }
  },
  methods: {
    handleMenu () {
      this.$store.commit('SET_LANDING_PAGE_SUB_MENU', !this.isLandingPageSubMenu)
    }
  },
  watch: {
    '$route' () {
      this.$store.commit('SET_LANDING_PAGE_SUB_MENU', false)
      // if (this.isActiveWearMenu) {
      //   this.$store.commit('SET_LANDING_PAGE_SUB_MENU', true)
      // } else {
      //   this.$store.commit('SET_LANDING_PAGE_SUB_MENU', false)
      // }
    }
  },
  mounted () {
    this.$store.commit('SET_LANDING_PAGE_SUB_MENU', false)
    // if (this.isActiveWearMenu) {
    //   this.$store.commit('SET_LANDING_PAGE_SUB_MENU', true)
    // } else {
    //   this.$store.commit('SET_LANDING_PAGE_SUB_MENU', false)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// AppNavLayout.vue?22f607d3